
export const prices = {
  title: "Precios curso 2026-2027",
  monthlyFees: {
    title: "Cuotas mensuales",
    subtitle: "10 pagos/año · Incluye enseñanza y materiales",
    tableHeaders: {
      level: "Nivel",
      firstChild: "1er hijo/a",
      secondChild: "2º hijo/a",
      thirdChild: "3er hijo/a"
    },
    infantil: {
      title: "INFANTIL",
      ageRange: "3 a 5 años",
      schedule: "8:45h a 14:00h"
    },
    primaryC1: {
      title: "PRIMARIA C1",
      ageRange: "6 a 8 años",
      schedule: "8:45h a 14:00h"
    },
    primaryC2: {
      title: "PRIMARIA C2",
      ageRange: "9 a 11 años",
      schedule: "8:45h a 14:00h"
    }
  },
  enrollment: {
    title: "Matrícula",
    description: "La matrícula incluye reserva de plaza, gestión administrativa y evaluación inicial",
    renewal: {
      title: "Renovación (familias actuales)",
      subtitle: "Matrícula anual para confirmar plaza",
      price: "350€",
      note: "Igual para todos los hermanos"
    },
    newStudents: {
      title: "Nuevos Alumnos",
      subtitle: "Matrícula primer año",
      firstChild: {
        title: "Primer hijo/a",
        price: "700€"
      },
      siblings: {
        title: "2º y 3er hijo/a",
        price: "350€"
      }
    }
  },
  specialDiscounts: {
    title: "Descuentos Especiales",
    earlyEnrollment: {
      title: "Matrícula Anticipada",
      description: "Realiza tu matrícula antes del 23 de febrero y ahorra 50€ por niño/a",
      badge: "-50€"
    },
    annualPayment: {
      title: "Pago Anual",
      description: "Paga el año completo por adelantado y obtén 200€ de descuento + 200€ en voucher para cumpleaños o campamentos",
      badges: {
        discount: "-200€",
        voucher: "+200€ voucher"
      }
    }
  },
  discounts: {
    title: "Descuentos por Hermanos",
    description: "Descuentos aplicados automáticamente en las mensualidades",
    secondChild: {
      title: "Segundo hijo/a",
      description: "20% de descuento sobre la mensualidad"
    },
    thirdChild: {
      title: "Tercer hijo/a y siguientes",
      description: "40% de descuento sobre la mensualidad"
    }
  },
  additionalServices: {
    title: "Servicios Adicionales",
    transport: {
      title: "Taxi desde Vigo",
      description: "Taxi desde Vigo. Mínimo 4 plazas. Es el único servicio con compromiso de reserva por todo el trimestre; la tarifa indicada es mensual.",
      roundTrip: {
        title: "Ida y vuelta",
        price: "225€/mes"
      }
    },
    earlyBirds: {
      title: "Early Birds (Lunes a Viernes incluidos)",
      monthly: {
        title: "Mensual",
        price: "75 €"
      },
      daily: {
        title: "Días sueltos",
        price: "7 € (pago máximo mensual 75 €)"
      },
      description: "Servicio diario a partir de las 8:15"
    },
    food: {
      title: "Comedor",
      monthly: {
        title: "5 días/semana",
        price: "195€"
      },
      threeDays: {
        title: "3 días/semana",
        price: "125€"
      },
      twoDays: {
        title: "2 días/semana",
        price: "90€"
      },
      daily: {
        title: "Días sueltos",
        price: "15€"
      },
      description: "Comida y snack de la mañana siguiendo una dieta equilibrada con productos ecológicos y locales. Los abonos de comedor se reservan y pagan mensualmente. Elige 5, 3 o 2 días fijos a la semana. Incluyen ludoteca hasta las 17:00 (viernes hasta las 16:00). Día suelto: avisar con 48 horas de antelación.",
      takeaway: {
        title: "Comida para llevar",
        description: "Por el mismo precio también se puede encargar la comida para recoger en cualquier momento entre las 14:00h y las 17:00h. El tupper lo proporciona Gándara."
      }
    },
    ludoteca: {
      title: "Ludoteca",
      schedule: "Horario: 15:00 a 17:00 (viernes hasta las 16:00)",
      freeService: "Gratis con comedor o extraescolares",
      dayPass: {
        title: "Día suelto"
      },
      oneDay: {
        title: "Un día/semana"
      },
      twoDays: {
        title: "Dos días/semana"
      },
      fiveDays: {
        title: "Cinco días/semana"
      },
      description: "Servicio de cuidado y actividades después del horario escolar"
    }
  },
  preEnrollment: {
    title: "¿Listo/a para dar el siguiente paso?",
    subtitle: "Únete a nuestra comunidad educativa en 3 sencillos pasos",
    steps: "Preinscripción → Visita guiada → Matrícula",
    ctaPrimary: "Solicitar Preinscripción",
    ctaSecondary: "Reservar una Visita",
    note: "El formulario de preinscripción no implica compromiso"
  }
};
